
<wiz-group  width="100%" height="100%">

    <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding: 5px; padding-left: 5px;">
        <wiz-icon class="basicIcon white hover" 
                (click)="showBurgerPop()"><mat-icon>menu</mat-icon></wiz-icon>
        
        <!-- <img src="assets/logo/logo-mobile512.png" width="30px" height="30px"/>
        
       <wiz-label [wizLabel]="'Texdecor Mobile Apps'" class="title" width="100%"></wiz-label> -->
       <wiz-label [wizLabel]="breadcrumb" class="smallTitle white" width="100%"></wiz-label>
       <!-- <wiz-spacer width="100%"></wiz-spacer> -->

        <button *ngIf="showInstallButton" (click)="installPWA()">
            Installer l’application
        </button>

       <wiz-icon class="image-back-orange" width="30px" height="30px" [wizTooltip]="'$.common.log-out.$'" (click)="do('disconnect')"  tooltipPlacement="left">log-out</wiz-icon>


       



        <!-- <wiz-hgroup width="100px" height="100%" verticalAlign="center" horizontalAlign="end" style="padding: 5px;">
            <wiz-icon class="basicIcon white hover"
                [wizTooltip]="'$.common.help.$'" (click)="do('help')" tooltipPlacement="bottom"><mat-icon>help_outline</mat-icon></wiz-icon>
            <wiz-icon class="basicIcon white hover" [wizTooltip]="userLabel" (click)="do('profile')" tooltipPlacement="bottom"><mat-icon>face</mat-icon></wiz-icon>
            <wiz-icon class="image-back-orange" [wizTooltip]="'$.common.log-out.$'" (click)="do('disconnect')"  tooltipPlacement="left">log-out</wiz-icon>
        </wiz-hgroup> -->

    </wiz-hgroup>


</wiz-group>


